import "styles/page.css";

import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import useStore from "stores/Store";
import { Link } from "react-router-dom";
import axios from "axios";
import parse from "html-react-parser";

import aboutusImg from "assets/images/about-us.png";
import { PrimaryButton } from "components/buttons";
import rightIcon from "assets/images/about_right.svg";
import aboutBgIcon from "assets/images/about_bg.svg";
import aboutBodIcon from "assets/images/about_bod.svg";
import aboutNewsIcon from "assets/images/about_news.svg";
import aboutReportIcon from "assets/images/about_report.svg";
import { isEmpty } from "lodash";

function About() {
  const { aboutState, setAboutState } = useStore();

  const fetchAboutData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/abouts?pLevel`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      const jsonResponse = response.data.data[0];
      setAboutState(jsonResponse);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (isEmpty(aboutState)) {
      fetchAboutData();
    }
  }, []);

  return (
    <>
      <style type="text/css">
        {`

          .about-us {
            margin-top: 40px;
          
            img {
              border-radius: 20px;
            }

            p {
              color: var(--gray-500-body-text, #72788E);
              font-family: "Ping AR + LT";
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%; /* 24px */
              letter-spacing: -0.368px;
            
              span {
                color: var(--alrajhi-Brand-600, #221AFB);
              }
            }
          }

          .about-card-row {
            --bs-gutter-x: 16px;
          }
          .about-card {
            border-radius: 15px;
            border: 1px solid var(--Gray-300, #D0D5DD);
            background: var(--white, #FFF);
            padding: 20px;
            margin: 8px;
            display: flex;
            align-items: center;

            p {
              padding: 0px 16px ;
              margin: 0px;
              color: var(--alrajhi-Brand-1000, #000045);
              text-align: left;
              font-family: "Ping AR + LT";
              font-size: 16px;
              font-style: normal;
              font-weight: 700;
              line-height: 24px; /* 150% */
            }

            img {
              width: 20px;
              height: 20px;
            }
          }

       
        `}
      </style>

      <div className="container about-us">
        {aboutState?.image ? (
          <img src={aboutState?.image} alt="banner" width={"100%"} />
        ) : (
          <img src={aboutState?.image_link} alt="banner" width={"100%"} />
        )}
        <div className="vertical-space"></div>
        {aboutState?.title && (
          <h4 className="page-heading">{parse(aboutState?.title)}</h4>
        )}
        {aboutState?.description && (
          <div className="page-subtitle">{parse(aboutState?.description)}</div>
        )}

        <div style={{ height: "40px" }}></div>
        <div className="d-flex justify-content-center">
          <Link to={aboutState?.moreButton?.link} target="blank">
            <PrimaryButton text={aboutState?.moreButton?.title} />
          </Link>
        </div>
        <div style={{ height: "40px" }}></div>
        <Row className="about-card-row">
          {/* <Col md={6} xs={12}>
            <Link
              style={{ textDecoration: "none" }}
              to="/about/corporate-info/our-background"
            >
              <div className="about-card">
                <img src={aboutBgIcon} alt="right" />
                <p className="flex-fill text-left">Our Background</p>
                <img src={rightIcon} alt="right" />
              </div>
            </Link>
          </Col> */}

          <Col xl={4} md={6} xs={12}>
            <Link style={{ textDecoration: "none" }} to="/financial-report">
              <div className="about-card">
                <img src={aboutReportIcon} alt="right" />
                <p className="flex-fill text-left">Financial Reports</p>
                <img src={rightIcon} alt="right" />
              </div>
            </Link>
          </Col>

          <Col xl={4} md={6} xs={12}>
            <Link
              style={{ textDecoration: "none" }}
              to="/about/corporate-profile/board-of-directors"
            >
              <div className="about-card">
                <img src={aboutBodIcon} alt="right" />
                <p className="flex-fill text-left">Board of Directors</p>
                <img src={rightIcon} alt="right" />
              </div>
            </Link>
          </Col>

          <Col xl={4} md={6} xs={12}>
            <Link style={{ textDecoration: "none" }} to="/news/">
              <div className="about-card">
                <img src={aboutNewsIcon} alt="right" />
                <p className="flex-fill text-left">News & Announcements</p>
                <img src={rightIcon} alt="right" />
              </div>
            </Link>
          </Col>
        </Row>
        <div style={{ height: "80px" }}></div>
      </div>
    </>
  );
}

export default About;
